import { render, staticRenderFns } from "./ParcelasMovimentacoesMinimas.vue?vue&type=template&id=8d166118&"
import script from "./ParcelasMovimentacoesMinimas.vue?vue&type=script&lang=js&"
export * from "./ParcelasMovimentacoesMinimas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports